import jump from 'jump.js'

let scrolling = false
const defaultDuration = 1000

function easeInOutCubic(t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t*t + b;
  return c/2*((t-=2)*t*t + 2) + b;
}

function easeInOutQuart(t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
  return -c/2 * ((t-=2)*t*t*t - 2) + b;
}

const easeInOutQuad = (t, b, c, d) => {
  t /= d / 2
  if (t < 1) return c / 2 * t * t + b
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

export function scrollToElement(hash, duration = defaultDuration, offset = 0) {
  // console.log('scroll.js scroll(hash) called,', hash)
  if (!hash) return false
  if (hash[0] !== '#') hash = `#${hash}`
  const element = document.querySelector(hash)
  // console.log('element', element)
  if (!element) {
    // console.log('no element return')
    return false
  }
  if (scrolling) {
    // console.log('scrolling return')
    return false
  }
  scrolling = true
  jump(hash, {
    duration,
    offset,
    callback: () => {
      scrolling = false
      // console.log('scroll callback called')
    },
    easing: easeInOutQuad,
  })
  return true
}

export function scrollTop(duration = defaultDuration) {
  // console.log('scrol.js scrollTop called')
  if (scrolling) return
  scrolling = true
  jump('#app', {
    offset: -100,
    duration,
    callback: () => { scrolling = false },
    easing: easeInOutQuad,
  })
}



// WEBPACK FOOTER //
// ./src/common/lib/scroll.js